<template>
  <footer class="footer bg-black">
    <div class="footer-content">
      <div class="footer-info">
        <span>BX201 서울대청년안심주택</span>
        <p>
          라온스테이2030 역세권청년주택 | 박정호외3인 | 전화번호: 02-3285-0201
          | 이메일: bx201@naver.com
        </p>
        <p>위탁관리사 : (주)대도오비씨 | 사업자등록번호 : 495-81-02530 | 주소 : 서울시 관악구 남부순환로 224길 25</p>
        <p>© 2025 청년주택. All rights reserved.</p>
      </div>
      <!-- <div class="footer-icons">
        <span>blog</span>
        <span>🍵</span>
        <span>f</span>
        <span>@</span>
      </div> -->
    </div>
  </footer>
</template>

<style scoped>
.footer {
  background: #000;
  color: #aaa;
  padding: 20px;
  font-size: 0.9rem;
  width: 100%; /* 푸터의 너비를 100%로 설정 */
  position: relative; /* 푸터가 콘텐츠 하단에 자연스럽게 배치되도록 설정 */
  bottom: 0;
  margin-top: auto; /* 이 부분이 중요: content가 적을 때도 하단에 붙도록 함 */
}
.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
}
.footer-info span {
  display: block;
  font-weight: bold;
  color: #fff;
  margin-bottom: 8px;
}
.footer-info a {
  color: #ccc;
  text-decoration: underline;
}
.footer-icons span {
  margin-left: 12px;
  font-size: 1.2rem;
  opacity: 0.6;
  cursor: pointer;
}

@media (max-width: 768px) {
    .footer {
      margin-bottom: 30px;
  }
}
</style>
